import Index from '@/views/billing/Index'
import Show from '@/views/billing/Show'

export default [
  {
    path: ':clientId/billing',
    name: 'billing.index',
    component: Index,
    meta: { breadcrumb: 'billing.name' }
  },
  {
    path: ':clientId/billing/:id',
    name: 'billing.show',
    component: Show,
    meta: { breadcrumb: route => `Profile ${route.params.id || ''}` }
  }
]
